import apiClient from './apiClient';

/**
 * Linha do agregador de versoes (1 por projeto).
 */
export interface AggregatedVersion {
  label: string;
  azureAppName?: string;
  url?: string;
  reachable: boolean;
  error?: string;
  project?: string;
  commitSha?: string;
  commitShortSha?: string;
  commitDate?: string;
  commitSubject?: string;
  branch?: string;
  buildDate?: string;
}

/**
 * Identificadores Azure usados pelo diagrama de arquitetura para montar links do portal.
 */
export interface AzureConfig {
  tenantId: string;
  subscriptionId: string;
  resourceGroup: string;
}

export const versionService = {
  /**
   * Chama o agregador da API que devolve [API, Monitor, BackgroundJobs, Receiver].
   * Path relativo ao baseURL do apiClient (que ja inclui /v1 em producao).
   */
  async getAll(): Promise<AggregatedVersion[]> {
    const res = await apiClient.get<AggregatedVersion[]>('/version/all');
    return res.data;
  },

  async getAzureConfig(): Promise<AzureConfig> {
    const res = await apiClient.get<AzureConfig>('/version/azure-config');
    return res.data;
  },
};
